import { debounce } from 'lodash';
import { Toast, Dialog } from 'vant';
// eslint-disable-next-line no-unused-vars
import axios, { AxiosResponse } from 'axios';
import config from 'common/config';

const reqTimes: any = {};
const showAlert = debounce(
  (message: string) => {
    if (config.isProd) {
      Dialog.alert({
        title: '异常提示',
        message,
      }).then(() => {
        // TODO: cat记录
      });
    }
  },
  5000,
  { leading: true },
);

export function responseHandler(response: AxiosResponse) {
  const { data } = response;
  const { error } = data;

  if (error) {
    error.msg = error.msg || `未知异常(${error.code})`;
    // 允许多个toast展示，防止toast过快消失
    Toast.allowMultiple(true);
    Toast(error.msg);
  }

  return data;
}

export function responseErrorHandler(error: any) {
  const {
    status = 0, statusText = '接口返回内容错误', config = {},
  } = error.response || {};
  const { url = 'about:blank' } = config || {};

  switch (status) {
    case 0:
      break;
    case 404:
      showAlert(`找不到接口 ${url}`);
      break;
    case 502:
      showAlert('接口网关异常，请稍后访问');
      break;
    case 504:
      showAlert(`接口 ${url} 超时，请稍后访问`);
      break;
    default:
      showAlert(`服务异常，请稍后访问${status}`);
      break;
  }

  return {
    data: null,
    error: {
      code: status,
      msg: statusText,
    },
  };
}

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use(
  (config: any) => {
    const key = config.url || 'unknown';
    reqTimes[key] = Date.now();
    return config;
  },
  (err) => Promise.reject(err),
);
axios.interceptors.response.use(responseHandler, responseErrorHandler);

export default axios;
